const Settings = {};

/**
 * Get a bool type setting from the redux store settings (aka Contentful)
 */
Settings.GetDynamicBool = function (
  SettingsDynamic,
  settingName,
  defaultValue,
) {
  if (SettingsDynamic.hasOwnProperty(settingName)) {
    if (
      SettingsDynamic[settingName].toLowerCase().trim() === "true" ||
      SettingsDynamic[settingName].toLowerCase().trim() === "yes" ||
      SettingsDynamic[settingName].toLowerCase().trim() === "1"
    ) {
      console.debug("Setting " + settingName + " is true");
      return true;
    } else {
      console.debug("Setting " + settingName + " is false");
      return false;
    }
  } else {
    console.debug("Setting " + settingName + " not found, defaulting to " + defaultValue);
    return defaultValue;
  }
};

// Recaptcha site key
Settings.RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// Show categories on the nominee listing page
if (process.env.REACT_APP_SHOW_CATEGORIES.toLowerCase().trim() === "true") {
  Settings.SHOW_CATEGORIES = true;
} else {
  Settings.SHOW_CATEGORIES = false;
}

// Allow voting
if (process.env.REACT_APP_ALLOW_VOTING.toLowerCase().trim() === "true") {
  Settings.ALLOW_VOTING = true; // force no voting
} else {
  Settings.ALLOW_VOTING = false;
}

// Voting closed
if (process.env.REACT_APP_VOTING_CLOSED.toLowerCase().trim() === "true") {
  Settings.VOTING_CLOSED = true;
} else {
  Settings.VOTING_CLOSED = false; // Force voting closed
}

Settings.CURRENT_HOF_YEAR = 2026;
// URL from which to submit the votes
Settings.ENDPOINT_VOTE = process.env.REACT_APP_ENDPOINT_VOTE;
// After voting, redirect to another URL
Settings.POST_VOTE_REDIRECT = process.env.REACT_APP_POST_VOTE_REDIRECT ?? false;
Settings.POST_VOTE_REDIRECT_URL =
  process.env.REACT_APP_POST_VOTE_REDIRECT_URL ?? "";
// URL from which to fetch the newsletter information
Settings.ENDPOINT_NEWSLETTER = process.env.REACT_APP_ENDPOINT_NEWSLETTER;
// URL from which to fetch the sweepstakes information
Settings.ENDPOINT_SWEEPSTAKES = process.env.REACT_APP_ENDPOINT_SWEEPSTAKES;
// URL from which to fetch the voting period information
Settings.ENDPOINT_PERIOD = process.env.REACT_APP_ENDPOINT_PERIOD;

Settings.languageFallback = "en-uk";

// These languages/Locales are available on the site
Settings.languages = [
  "en-us",
  "en-uk",
  "en-ie",
  "en-eu",
  "de-de",
  "de-at",
  "fr-fr",
  "nl-nl",
  "it-it",
  "fr-be",
  "nl-be",
  "pt-pt",
  "es-es",
];

// These languages will be redirected to the EU site
Settings.languagesEU = [
  "en-EU",
  "en-eu",
  "AD",
  "bs",
  "bg",
  "bg-BG",
  "bg-bg",
  "bs-BA",
  "bs-ba",
  "ca-AD",
  "ca-ad",
  "ca-ES",
  "ca-es",
  "ca",
  "hr-HR",
  "hr-hr",
  "hr",
  "cs-CZ",
  "cs-cz",
  "cs",
  "da-DK",
  "da-dk",
  "da",
  "en-AU",
  "en-au",
  "en-MT",
  "en-mt",
  "et-EE",
  "et-ee",
  "et",
  "fi-FI",
  "fi-fi",
  "fi",
  "el-CY",
  "el-cy",
  "el-GR",
  "el-gr",
  "el",
  "hu-HU",
  "hu-hu",
  "hu",
  "ga-IE",
  "ga-ie",
  "ga",
  "gl",
  "gl-ES",
  "gl-es",
  "it-CH",
  "it-ch",
  "lv-LV",
  "lv-lv",
  "lv",
  "lt-LT",
  "lt-lt",
  "lt",
  "mt-MT",
  "mt-mt",
  "mt",
  "pl-PL",
  "pl-pl",
  "pl",
  "ro-RO",
  "ro-ro",
  "ro",
  "sk-SK",
  "sk-sk",
  "sk",
  "sl-SI",
  "sl-si",
  "sl",
  "sv-SE",
  "sv-se",
  "sv",
  // Technically not EU countries
  "bs",
  "bs-BA",
  "bs-ba",
  "sq",
  "sq-AL",
  "sq-al",
  "hy",
  "hy-AM",
  "hy-am",
  "az",
  "az-AZ",
  "az-az",
  "be",
  "be-BY",
  "be-by",
  "bs",
  "bs-BA",
  "bs-ba",
  "ka",
  "ka-GE",
  "ka-ge",
  "kk",
  "kk-KZ",
  "kk-kz",
  "sr-BA",
  "sr-ba",
  "sr-SP",
  "sr-sp",
  "sr-SP",
  "sr-sp",
  "mk",
  "mk-MK",
  "mk-mk",
  "tr",
  "tr-TR",
  "tr-tr",
  "uk",
  "uk-UA",
  "uk-ua",
];

// These languages will be redirected to the GB site
Settings.languagesUK = ["en-gb", "en-uk"];

// These languages will be redirected to the IE site
Settings.languagesIE = ["en-ie"];

// These languages will be redirected to the FR site
Settings.languagesFR = ["fr-ca", "fr-lu", "fr-ch", "fr-fr", "fr-mc"];

// These languages will be redirected to the DE site
Settings.languagesDE = ["de-de", "de-lu", "de-ch", "de-li", "de"];

// Austria
Settings.languagesAT = ["de-at"];

// Netherlands
Settings.languagesNL = ["nl", "nl-nl"];

// Italy
Settings.languagesIT = ["it-it"];

// Belgium (French)
Settings.languagesBEfr = ["fr-be"];

// Belgium (Dutch)
Settings.languagesBEnl = ["nl-be"];

// Portugal
Settings.languagesPT = ["pt-pt", "br-br"];

// Spain
Settings.languagesES = [
  "es-es",
  "ar-ar",
  "bo-bo",
  "cl-cl",
  "co-co",
  "cr-cr",
  "do-do",
  "ec-ec",
  "sv-sv",
  "gt-gt",
  "hn-hn",
  "mx-mx",
  "ni-ni",
  "pa-pa",
  "py-py",
  "pe-pe",
  "uy-uy",
  "ve-ve",
];

Settings.USA_STATES = [
  { lab: "Alabama", value: "Alabama", code: "AL" },
  { lab: "Alaska", value: "Alaska", code: "AK" },
  { lab: "Arizona", value: "Arizona", code: "AZ" },
  { lab: "Arkansas", value: "Arkansas", code: "AR" },
  { lab: "California", value: "California", code: "CA" },
  { lab: "Colorado", value: "Colorado", code: "CO" },
  { lab: "Connecticut", value: "Connecticut", code: "CT" },
  { lab: "Delaware", value: "Delaware", code: "DE" },
  { lab: "District of Columbia", value: "District of Columbia", code: "DC" },
  { lab: "Florida", value: "Florida", code: "FL" },
  { lab: "Georgia", value: "Georgia", code: "GA" },
  { lab: "Hawaii", value: "Hawaii", code: "HI" },
  { lab: "Idaho", value: "Idaho", code: "ID" },
  { lab: "Illinois", value: "Illinois", code: "IL" },
  { lab: "Indiana", value: "Indiana", code: "IN" },
  { lab: "Iowa", value: "Iowa", code: "IA" },
  { lab: "Kansas", value: "Kansas", code: "KS" },
  { lab: "Kentucky", value: "Kentucky", code: "KY" },
  { lab: "Louisiana", value: "Louisiana", code: "LA" },
  { lab: "Maine", value: "Maine", code: "ME" },
  { lab: "Maryland", value: "Maryland", code: "MD" },
  { lab: "Massachusetts", value: "Massachusetts", code: "MA" },
  { lab: "Michigan", value: "Michigan", code: "MI" },
  { lab: "Minnesota", value: "Minnesota", code: "MN" },
  { lab: "Mississippi", value: "Mississippi", code: "MS" },
  { lab: "Missouri", value: "Missouri", code: "MO" },
  { lab: "Montana", value: "Montana", code: "MT" },
  { lab: "Nebraska", value: "Nebraska", code: "NE" },
  { lab: "Nevada", value: "Nevada", code: "NV" },
  { lab: "New Hampshire", value: "New Hampshire", code: "NH" },
  { lab: "New Jersey", value: "New Jersey", code: "NJ" },
  { lab: "New Mexico", value: "New Mexico", code: "NM" },
  { lab: "New York", value: "New York", code: "NY" },
  { lab: "North Carolina", value: "North Carolina", code: "NC" },
  { lab: "North Dakota", value: "North Dakota", code: "ND" },
  { lab: "Ohio", value: "Ohio", code: "OH" },
  { lab: "Oklahoma", value: "Oklahoma", code: "OK" },
  { lab: "Oregon", value: "Oregon", code: "OR" },
  { lab: "Pennsylvania", value: "Pennsylvania", code: "PA" },
  { lab: "Rhode Island", value: "Rhode Island", code: "RI" },
  { lab: "South Carolina", value: "South Carolina", code: "SC" },
  { lab: "South Dakota", value: "South Dakota", code: "SD" },
  { lab: "Tennessee", value: "Tennessee", code: "TN" },
  { lab: "Texas", value: "Texas", code: "TX" },
  { lab: "Utah", value: "Utah", code: "UT" },
  { lab: "Vermont", value: "Vermont", code: "VT" },
  { lab: "Virginia", value: "Virginia", code: "VA" },
  { lab: "Washington", value: "Washington", code: "WA" },
  { lab: "West Virginia", value: "West Virginia", code: "WV" },
  { lab: "Wisconsin", value: "Wisconsin", code: "WI" },
  { lab: "Wyoming", value: "Wyoming", code: "WY" },
];

Settings.countryOptions = [
  {
    lab: "United Kingdom",
    value: "United Kingdom",
    code: "GB",
    locale: "en-uk",
  },
  {
    lab: "United States",
    value: "United States",
    code: "US",
    locale: "en-us",
  },
  {
    lab: "Germany",
    value: "Germany",
    code: "DE",
    locale: "de-de",
  },
  {
    lab: "France",
    value: "France",
    code: "FR",
    locale: "fr-fr",
  },
  {
    lab: "Netherlands",
    value: "Netherlands",
    code: "NL",
    locale: "nl-nl",
  },
  {
    lab: "Italy",
    value: "Italy",
    code: "IT",
    locale: "it-it",
  },
  {
    lab: "Austria",
    value: "Austria",
    code: "AT",
    locale: "de-at",
  },
  {
    lab: "Belgium",
    value: "Belgium",
    code: "BE",
    locale: "fr-be",
  },
  {
    lab: "Ireland",
    value: "Ireland",
    code: "IE",
    locale: "en-ie",
  },
  {
    lab: "Spain",
    value: "Spain",
    code: "ES",
    locale: "es-es",
  },
  {
    lab: "Portugal",
    value: "Portugal",
    code: "PT",
    locale: "pt-pt",
  },
  {
    lab: "Afghanistan",
    value: "Afghanistan",
    code: "AF",
  },
  {
    lab: "Aland Islands",
    value: "Aland Islands",
    code: "",
  },
  {
    lab: "Albania",
    value: "Albania",
    code: "",
    locale: "sq-al",
  },
  {
    lab: "Algeria",
    value: "Algeria",
    code: "",
  },
  {
    lab: "American Samoa",
    value: "American Samoa",
    code: "",
  },
  {
    lab: "Andorra",
    value: "Andorra",
    code: "",
  },
  {
    lab: "Angola",
    value: "Angola",
    code: "",
  },
  {
    lab: "Anguilla",
    value: "Anguilla",
    code: "",
  },
  {
    lab: "Antarctica",
    value: "Antarctica",
    code: "",
  },
  {
    lab: "Antigua and Barbuda",
    value: "Antigua and Barbuda",
    code: "",
  },
  {
    lab: "Argentina",
    value: "Argentina",
    code: "",
  },
  {
    lab: "Armenia",
    value: "Armenia",
    code: "",
    locale: "hy-am",
  },
  {
    lab: "Aruba",
    value: "Aruba",
    code: "",
  },
  {
    lab: "Australia",
    value: "Australia",
    code: "AU",
  },
  {
    lab: "Azerbaijan",
    value: "Azerbaijan",
    code: "",
    locale: "az-az",
  },
  {
    lab: "Bahamas",
    value: "Bahamas",
    code: "",
  },
  {
    lab: "Bahrain",
    value: "Bahrain",
    code: "",
  },
  {
    lab: "Bangladesh",
    value: "Bangladesh",
    code: "",
  },
  {
    lab: "Barbados",
    value: "Barbados",
    code: "",
  },
  {
    lab: "Belarus",
    value: "Belarus",
    code: "",
    locale: "be-by",
  },
  {
    lab: "Belize",
    value: "Belize",
    code: "",
  },
  {
    lab: "Benin",
    value: "Benin",
    code: "",
  },
  {
    lab: "Bermuda",
    value: "Bermuda",
    code: "",
  },
  {
    lab: "Bhutan",
    value: "Bhutan",
    code: "",
  },
  {
    lab: "Bolivia",
    value: "Bolivia",
    code: "",
  },
  {
    lab: "Bonaire, Sint Eustatius and Saba",
    value: "Bonaire, Sint Eustatius and Saba",
    code: "",
  },
  {
    lab: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
    code: "",
    locale: "bs-ba",
  },
  {
    lab: "Botswana",
    value: "Botswana",
    code: "",
  },
  {
    lab: "Bouvet Island",
    value: "Bouvet Island",
    code: "",
  },
  {
    lab: "Brazil",
    value: "Brazil",
    code: "BR",
  },
  {
    lab: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
    code: "",
  },
  {
    lab: "Brunei Darussalam",
    value: "Brunei Darussalam",
    code: "",
  },
  {
    lab: "Bulgaria",
    value: "Bulgaria",
    code: "",
    locale: "bg-bg",
  },
  {
    lab: "Burkina Faso",
    value: "Burkina Faso",
    code: "",
  },
  {
    lab: "Burundi",
    value: "Burundi",
    code: "",
  },
  {
    lab: "Cambodia",
    value: "Cambodia",
    code: "",
  },
  {
    lab: "Cameroon",
    value: "Cameroon",
    code: "",
  },
  {
    lab: "Canada",
    value: "Canada",
    code: "CA",
  },
  {
    lab: "Cape Verde",
    value: "Cape Verde",
    code: "",
  },
  {
    lab: "Cayman Islands",
    value: "Cayman Islands",
    code: "",
  },
  {
    lab: "Central African Republic",
    value: "Central African Republic",
    code: "",
  },
  {
    lab: "Chad",
    value: "Chad",
    code: "",
  },
  {
    lab: "Chile",
    value: "Chile",
    code: "",
  },
  {
    lab: "China",
    value: "China",
    code: "CN",
  },
  {
    lab: "Christmas Island",
    value: "Christmas Island",
    code: "",
  },
  {
    lab: "Cocos (Keeling) Islands",
    value: "Cocos (Keeling) Islands",
    code: "",
  },
  {
    lab: "Colombia",
    value: "Colombia",
    code: "",
  },
  {
    lab: "Comoros",
    value: "Comoros",
    code: "",
  },
  {
    lab: "Congo",
    value: "Congo",
    code: "",
  },
  {
    lab: "Congo, Democratic Republic of the Congo",
    value: "Congo, Democratic Republic of the Congo",
    code: "",
  },
  {
    lab: "Cook Islands",
    value: "Cook Islands",
    code: "",
  },
  {
    lab: "Costa Rica",
    value: "Costa Rica",
    code: "",
  },
  {
    lab: "Cote D'Ivoire",
    value: "Cote D'Ivoire",
    code: "",
  },
  {
    lab: "Croatia",
    value: "Croatia",
    code: "",
    locale: "hr-hr",
  },
  {
    lab: "Cuba",
    value: "Cuba",
    code: "",
  },
  {
    lab: "Curacao",
    value: "Curacao",
    code: "",
  },
  {
    lab: "Cyprus",
    value: "Cyprus",
    code: "",
    locale: "el-cy",
  },
  {
    lab: "Czech Republic",
    value: "Czech Republic",
    code: "CZ",
    locale: "cs-cz",
  },
  {
    lab: "Denmark",
    value: "Denmark",
    code: "DK",
    locale: "da-dk",
  },
  {
    lab: "Djibouti",
    value: "Djibouti",
    code: "",
  },
  {
    lab: "Dominica",
    value: "Dominica",
    code: "",
  },
  {
    lab: "Dominican Republic",
    value: "Dominican Republic",
    code: "",
  },
  {
    lab: "Ecuador",
    value: "Ecuador",
    code: "",
  },
  {
    lab: "Egypt",
    value: "Egypt",
    code: "",
  },
  {
    lab: "El Salvador",
    value: "El Salvador",
    code: "",
  },
  {
    lab: "Equatorial Guinea",
    value: "Equatorial Guinea",
    code: "",
  },
  {
    lab: "Eritrea",
    value: "Eritrea",
    code: "",
  },
  {
    lab: "Estonia",
    value: "Estonia",
    code: "",
    locale: "et-ee",
  },
  {
    lab: "Ethiopia",
    value: "Ethiopia",
    code: "",
  },
  {
    lab: "Falkland Islands (Malvinas)",
    value: "Falkland Islands (Malvinas)",
    code: "",
  },
  {
    lab: "Faroe Islands",
    value: "Faroe Islands",
    code: "",
  },
  {
    lab: "Fiji",
    value: "Fiji",
    code: "",
  },
  {
    lab: "Finland",
    value: "Finland",
    code: "",
    locale: "fi-fi",
  },
  {
    lab: "French Guiana",
    value: "French Guiana",
    code: "",
  },
  {
    lab: "French Polynesia",
    value: "French Polynesia",
    code: "",
  },
  {
    lab: "French Southern Territories",
    value: "French Southern Territories",
    code: "",
  },
  {
    lab: "Gabon",
    value: "Gabon",
    code: "",
  },
  {
    lab: "Gambia",
    value: "Gambia",
    code: "",
  },
  {
    lab: "Georgia",
    value: "Georgia",
    code: "",
    locale: "ka-ge",
  },
  {
    lab: "Ghana",
    value: "Ghana",
    code: "",
  },
  {
    lab: "Gibraltar",
    value: "Gibraltar",
    code: "",
  },
  {
    lab: "Greece",
    value: "Greece",
    code: "GR",
    locale: "el-gr",
  },
  {
    lab: "Greenland",
    value: "Greenland",
    code: "",
  },
  {
    lab: "Grenada",
    value: "Grenada",
    code: "",
  },
  {
    lab: "Guadeloupe",
    value: "Guadeloupe",
    code: "",
  },
  {
    lab: "Guam",
    value: "Guam",
    code: "",
  },
  {
    lab: "Guatemala",
    value: "Guatemala",
    code: "",
  },
  {
    lab: "Guernsey",
    value: "Guernsey",
    code: "",
  },
  {
    lab: "Guinea",
    value: "Guinea",
    code: "",
  },
  {
    lab: "Guinea-Bissau",
    value: "Guinea-Bissau",
    code: "",
  },
  {
    lab: "Guyana",
    value: "Guyana",
    code: "",
  },
  {
    lab: "Haiti",
    value: "Haiti",
    code: "",
  },
  {
    lab: "Heard Island and Mcdonald Islands",
    value: "Heard Island and Mcdonald Islands",
    code: "",
  },
  {
    lab: "Holy See (Vatican City State)",
    value: "Holy See (Vatican City State)",
    code: "",
  },
  {
    lab: "Honduras",
    value: "Honduras",
    code: "",
  },
  {
    lab: "Hong Kong",
    value: "Hong Kong",
    code: "HK",
  },
  {
    lab: "Hungary",
    value: "Hungary",
    code: "HU",
    locale: "hu-hu",
  },
  {
    lab: "Iceland",
    value: "Iceland",
    code: "",
  },
  {
    lab: "India",
    value: "India",
    code: "IN",
  },
  {
    lab: "Indonesia",
    value: "Indonesia",
    code: "",
  },
  {
    lab: "Iran, Islamic Republic of",
    value: "Iran, Islamic Republic of",
    code: "",
  },
  {
    lab: "Iraq",
    value: "Iraq",
    code: "",
  },
  {
    lab: "Isle of Man",
    value: "Isle of Man",
    code: "",
  },
  {
    lab: "Israel",
    value: "Israel",
    code: "",
  },
  {
    lab: "Jamaica",
    value: "Jamaica",
    code: "",
  },
  {
    lab: "Japan",
    value: "Japan",
    code: "JP",
  },
  {
    lab: "Jersey",
    value: "Jersey",
    code: "",
  },
  {
    lab: "Jordan",
    value: "Jordan",
    code: "",
  },
  {
    lab: "Kazakhstan",
    value: "Kazakhstan",
    code: "",
    locale: "kk-kz",
  },
  {
    lab: "Kenya",
    value: "Kenya",
    code: "",
  },
  {
    lab: "Kiribati",
    value: "Kiribati",
    code: "",
  },
  {
    lab: "Korea, Democratic People's Republic of",
    value: "Korea, Democratic People's Republic of",
    code: "",
  },
  {
    lab: "Korea, Republic of",
    value: "Korea, Republic of",
    code: "",
  },
  {
    lab: "Kosovo",
    value: "Kosovo",
    code: "",
  },
  {
    lab: "Kuwait",
    value: "Kuwait",
    code: "",
  },
  {
    lab: "Kyrgyzstan",
    value: "Kyrgyzstan",
    code: "",
  },
  {
    lab: "Lao People's Democratic Republic",
    value: "Lao People's Democratic Republic",
    code: "",
  },
  {
    lab: "Latvia",
    value: "Latvia",
    code: "",
    locale: "lv-lv",
  },
  {
    lab: "Lebanon",
    value: "Lebanon",
    code: "",
  },
  {
    lab: "Lesotho",
    value: "Lesotho",
    code: "",
  },
  {
    lab: "Liberia",
    value: "Liberia",
    code: "",
  },
  {
    lab: "Libyan Arab Jamahiriya",
    value: "Libyan Arab Jamahiriya",
    code: "",
  },
  {
    lab: "Liechtenstein",
    value: "Liechtenstein",
    code: "",
  },
  {
    lab: "Lithuania",
    value: "Lithuania",
    code: "",
    locale: "lt-lt",
  },
  {
    lab: "Luxembourg",
    value: "Luxembourg",
    code: "",
    locale: "lu-lu",
  },
  {
    lab: "Macao",
    value: "Macao",
    code: "",
  },
  {
    lab: "Macedonia, the Former Yugoslav Republic of",
    value: "Macedonia, the Former Yugoslav Republic of",
    code: "",
    locale: "mk-mk",
  },
  {
    lab: "Madagascar",
    value: "Madagascar",
    code: "",
  },
  {
    lab: "Malawi",
    value: "Malawi",
    code: "",
  },
  {
    lab: "Malaysia",
    value: "Malaysia",
    code: "",
  },
  {
    lab: "Maldives",
    value: "Maldives",
    code: "",
  },
  {
    lab: "Mali",
    value: "Mali",
    code: "",
  },
  {
    lab: "Malta",
    value: "Malta",
    code: "",
    locale: "mt-mt",
  },
  {
    lab: "Marshall Islands",
    value: "Marshall Islands",
    code: "",
  },
  {
    lab: "Martinique",
    value: "Martinique",
    code: "",
  },
  {
    lab: "Mauritania",
    value: "Mauritania",
    code: "",
  },
  {
    lab: "Mauritius",
    value: "Mauritius",
    code: "",
  },
  {
    lab: "Mayotte",
    value: "Mayotte",
    code: "",
  },
  {
    lab: "Mexico",
    value: "Mexico",
    code: "",
  },
  {
    lab: "Micronesia, Federated States of",
    value: "Micronesia, Federated States of",
    code: "",
  },
  {
    lab: "Moldova, Republic of",
    value: "Moldova, Republic of",
    code: "",
  },
  {
    lab: "Monaco",
    value: "Monaco",
    code: "",
  },
  {
    lab: "Mongolia",
    value: "Mongolia",
    code: "",
  },
  {
    lab: "Montenegro",
    value: "Montenegro",
    code: "",
  },
  {
    lab: "Montserrat",
    value: "Montserrat",
    code: "",
  },
  {
    lab: "Morocco",
    value: "Morocco",
    code: "",
  },
  {
    lab: "Mozambique",
    value: "Mozambique",
    code: "",
  },
  {
    lab: "Myanmar",
    value: "Myanmar",
    code: "",
  },
  {
    lab: "Namibia",
    value: "Namibia",
    code: "",
  },
  {
    lab: "Nauru",
    value: "Nauru",
    code: "",
  },
  {
    lab: "Nepal",
    value: "Nepal",
    code: "",
  },
  {
    lab: "Netherlands Antilles",
    value: "Netherlands Antilles",
    code: "",
  },
  {
    lab: "New Caledonia",
    value: "New Caledonia",
    code: "",
  },
  {
    lab: "New Zealand",
    value: "New Zealand",
    code: "",
  },
  {
    lab: "Nicaragua",
    value: "Nicaragua",
    code: "",
  },
  {
    lab: "Niger",
    value: "Niger",
    code: "",
  },
  {
    lab: "Nigeria",
    value: "Nigeria",
    code: "",
  },
  {
    lab: "Niue",
    value: "Niue",
    code: "",
  },
  {
    lab: "Norfolk Island",
    value: "Norfolk Island",
    code: "",
  },
  {
    lab: "Northern Mariana Islands",
    value: "Northern Mariana Islands",
    code: "",
  },
  {
    lab: "Norway",
    value: "Norway",
    code: "NO",
  },
  {
    lab: "Oman",
    value: "Oman",
    code: "",
  },
  {
    lab: "Pakistan",
    value: "Pakistan",
    code: "",
  },
  {
    lab: "Palau",
    value: "Palau",
    code: "",
  },
  {
    lab: "Palestinian Territory, Occupied",
    value: "Palestinian Territory, Occupied",
    code: "",
  },
  {
    lab: "Panama",
    value: "Panama",
    code: "",
  },
  {
    lab: "Papua New Guinea",
    value: "Papua New Guinea",
    code: "",
  },
  {
    lab: "Paraguay",
    value: "Paraguay",
    code: "",
  },
  {
    lab: "Peru",
    value: "Peru",
    code: "",
  },
  {
    lab: "Philippines",
    value: "Philippines",
    code: "",
  },
  {
    lab: "Pitcairn",
    value: "Pitcairn",
    code: "",
  },
  {
    lab: "Poland",
    value: "Poland",
    code: "PL",
    locale: "pl-pl",
  },
  {
    lab: "Puerto Rico",
    value: "Puerto Rico",
    code: "",
  },
  {
    lab: "Qatar",
    value: "Qatar",
    code: "",
  },
  {
    lab: "Reunion",
    value: "Reunion",
    code: "",
  },
  {
    lab: "Romania",
    value: "Romania",
    code: "",
    locale: "ro-ro",
  },
  {
    lab: "Russian Federation",
    value: "Russian Federation",
    code: "",
  },
  {
    lab: "Rwanda",
    value: "Rwanda",
    code: "",
  },
  {
    lab: "Saint Barthelemy",
    value: "Saint Barthelemy",
    code: "",
  },
  {
    lab: "Saint Helena",
    value: "Saint Helena",
    code: "",
  },
  {
    lab: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
    code: "",
  },
  {
    lab: "Saint Lucia",
    value: "Saint Lucia",
    code: "",
  },
  {
    lab: "Saint Martin",
    value: "Saint Martin",
    code: "",
  },
  {
    lab: "Saint Pierre and Miquelon",
    value: "Saint Pierre and Miquelon",
    code: "",
  },
  {
    lab: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
    code: "",
  },
  {
    lab: "Samoa",
    value: "Samoa",
    code: "",
  },
  {
    lab: "San Marino",
    value: "San Marino",
    code: "",
  },
  {
    lab: "Sao Tome and Principe",
    value: "Sao Tome and Principe",
    code: "",
  },
  {
    lab: "Saudi Arabia",
    value: "Saudi Arabia",
    code: "",
  },
  {
    lab: "Senegal",
    value: "Senegal",
    code: "",
  },
  {
    lab: "Serbia",
    value: "Serbia",
    code: "",
    locale: "sr-sp",
  },
  {
    lab: "Serbia and Montenegro",
    value: "Serbia and Montenegro",
    code: "",
  },
  {
    lab: "Seychelles",
    value: "Seychelles",
    code: "",
  },
  {
    lab: "Sierra Leone",
    value: "Sierra Leone",
    code: "",
  },
  {
    lab: "Singapore",
    value: "Singapore",
    code: "",
  },
  {
    lab: "Sint Maarten",
    value: "Sint Maarten",
    code: "",
  },
  {
    lab: "Slovakia",
    value: "Slovakia",
    code: "",
    locale: "sk-sk",
  },
  {
    lab: "Slovenia",
    value: "Slovenia",
    code: "",
    locale: "sl-sl",
  },
  {
    lab: "Solomon Islands",
    value: "Solomon Islands",
    code: "",
  },
  {
    lab: "Somalia",
    value: "Somalia",
    code: "",
  },
  {
    lab: "South Africa",
    value: "South Africa",
    code: "ZA",
  },
  {
    lab: "South Georgia and the South Sandwich Islands",
    value: "South Georgia and the South Sandwich Islands",
    code: "",
  },
  {
    lab: "South Sudan",
    value: "South Sudan",
    code: "",
  },
  {
    lab: "Sri Lanka",
    value: "Sri Lanka",
    code: "",
  },
  {
    lab: "Sudan",
    value: "Sudan",
    code: "",
  },
  {
    lab: "Suriname",
    value: "Suriname",
    code: "",
  },
  {
    lab: "Svalbard and Jan Mayen",
    value: "Svalbard and Jan Mayen",
    code: "",
  },
  {
    lab: "Swaziland",
    value: "Swaziland",
    code: "",
  },
  {
    lab: "Sweden",
    value: "Sweden",
    code: "SK",
    locale: "sv-se",
  },
  {
    lab: "Switzerland",
    value: "Switzerland",
    code: "CH",
    locale: "de-ch",
  },
  {
    lab: "Syrian Arab Republic",
    value: "Syrian Arab Republic",
    code: "",
  },
  {
    lab: "Taiwan, Province of China",
    value: "Taiwan, Province of China",
    code: "",
  },
  {
    lab: "Tajikistan",
    value: "Tajikistan",
    code: "",
  },
  {
    lab: "Tanzania, United Republic of",
    value: "Tanzania, United Republic of",
    code: "",
  },
  {
    lab: "Thailand",
    value: "Thailand",
    code: "",
  },
  {
    lab: "Timor-Leste",
    value: "Timor-Leste",
    code: "",
  },
  {
    lab: "Togo",
    value: "Togo",
    code: "",
  },
  {
    lab: "Tokelau",
    value: "Tokelau",
    code: "",
  },
  {
    lab: "Tonga",
    value: "Tonga",
    code: "",
  },
  {
    lab: "Trinidad and Tobago",
    value: "Trinidad and Tobago",
    code: "",
  },
  {
    lab: "Tunisia",
    value: "Tunisia",
    code: "",
  },
  {
    lab: "Turkey",
    value: "Turkey",
    code: "",
    locale: "tr-tr",
  },
  {
    lab: "Turkmenistan",
    value: "Turkmenistan",
    code: "",
  },
  {
    lab: "Turks and Caicos Islands",
    value: "Turks and Caicos Islands",
    code: "",
  },
  {
    lab: "Tuvalu",
    value: "Tuvalu",
    code: "",
  },
  {
    lab: "Uganda",
    value: "Uganda",
    code: "",
  },
  {
    lab: "Ukraine",
    value: "Ukraine",
    code: "",
    locale: "uk-ua",
  },
  {
    lab: "United Arab Emirates",
    value: "United Arab Emirates",
    code: "",
  },
  {
    lab: "United Kingdom",
    value: "United Kingdom",
    code: "GB",
  },
  {
    lab: "United States",
    value: "United States",
    code: "US",
  },
  {
    lab: "United States Minor Outlying Islands",
    value: "United States Minor Outlying Islands",
    code: "",
  },
  {
    lab: "Uruguay",
    value: "Uruguay",
    code: "",
  },
  {
    lab: "Uzbekistan",
    value: "Uzbekistan",
    code: "",
  },
  {
    lab: "Vanuatu",
    value: "Vanuatu",
    code: "",
  },
  {
    lab: "Venezuela",
    value: "Venezuela",
    code: "",
  },
  {
    lab: "Viet Nam",
    value: "Viet Nam",
    code: "",
  },
  {
    lab: "Virgin Islands, British",
    value: "Virgin Islands, British",
    code: "",
  },
  {
    lab: "Virgin Islands, U.s.",
    value: "Virgin Islands, U.s.",
    code: "",
  },
  {
    lab: "Wallis and Futuna",
    value: "Wallis and Futuna",
    code: "",
  },
  {
    lab: "Western Sahara",
    value: "Western Sahara",
    code: "",
  },
  {
    lab: "Yemen",
    value: "Yemen",
    code: "",
  },
  {
    lab: "Zambia",
    value: "Zambia",
    code: "",
  },
  {
    lab: "Zimbabwe",
    value: "Zimbabwe",
    code: "",
  },
];

Settings.countries_fr = [
  "L'Afghanistan",
  "Iles Aland",
  "Albanie",
  "Algérie",
  "Samoa américaines",
  "Andorre",
  "L'Angola",
  "Anguilla",
  "Antarctique",
  "Antigua-et-Barbuda",
  "Argentine",
  "Arménie",
  "Aruba",
  "Australie",
  "L'Autriche",
  "Azerbaïdjan",
  "Bahamas",
  "Bahreïn",
  "Bangladesh",
  "Barbade",
  "Biélorussie",
  "Belgique",
  "Belize",
  "Bénin",
  "Bermudes",
  "Bhoutan",
  "Bolivie",
  "Bonaire, Saint-Eustache et Saba",
  "Bosnie Herzégovine",
  "Botswana",
  "Île Bouvet",
  "Brésil",
  "Territoire britannique de l'océan Indien",
  "Brunei Darussalam",
  "Bulgarie",
  "Burkina Faso",
  "Burundi",
  "Cambodge",
  "Cameroun",
  "Canada",
  "Cap-Vert",
  "Îles Caïmans",
  "République centrafricaine",
  "Tchad",
  "Chili",
  "Chine",
  "L'île de noël",
  "Îles Cocos (Keeling)",
  "Colombie",
  "Comores",
  "Congo",
  "Congo, République démocratique du Congo",
  "les Îles Cook",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatie",
  "Cuba",
  "Curacao",
  "Chypre",
  "République Tchèque",
  "Danemark",
  "Djibouti",
  "Dominique",
  "République dominicaine",
  "Equateur",
  "Egypte",
  "Le Salvador",
  "Guinée Équatoriale",
  "Érythrée",
  "Estonie",
  "Ethiopie",
  "Îles Falkland (Malvinas)",
  "Îles Féroé",
  "Fidji",
  "Finlande",
  "France",
  "Guyane Française",
  "Polynésie française",
  "Terres australes françaises",
  "Gabon",
  "Gambie",
  "Géorgie",
  "Allemagne",
  "Ghana",
  "Gibraltar",
  "Grèce",
  "Groenland",
  "Grenade",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernesey",
  "Guinée",
  "Guinée-Bissau",
  "Guyane",
  "Haïti",
  "Îles Heard et McDonald",
  "Saint-Siège (État de la Cité du Vatican)",
  "Honduras",
  "Hong Kong",
  "Hongrie",
  "Islande",
  "Inde",
  "Indonésie",
  "Iran (République islamique d",
  "Irak",
  "Irlande",
  "île de Man",
  "Israël",
  "Italie",
  "Jamaïque",
  "Japon",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "République populaire démocratique de Corée",
  "Corée, République de",
  "Kosovo",
  "Koweit",
  "Kirghizistan",
  "République démocratique populaire lao",
  "Lettonie",
  "Liban",
  "Lesotho",
  "Libéria",
  "Jamahiriya arabe libyenne",
  "Liechtenstein",
  "Lituanie",
  "Luxembourg",
  "Macao",
  "Macédoine, ancienne République yougoslave de",
  "Madagascar",
  "Malawi",
  "Malaisie",
  "Maldives",
  "Mali",
  "Malte",
  "Iles Marshall",
  "Martinique",
  "Mauritanie",
  "Ile Maurice",
  "Mayotte",
  "Mexique",
  "Micronésie, États fédérés de",
  "Moldova, République de",
  "Monaco",
  "Mongolie",
  "Monténégro",
  "Montserrat",
  "Maroc",
  "Mozambique",
  "Myanmar",
  "Namibie",
  "Nauru",
  "Népal",
  "Pays-Bas",
  "Antilles néerlandaises",
  "Nouvelle Calédonie",
  "Nouvelle-Zélande",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "l'ile de Norfolk",
  "Îles Mariannes du Nord",
  "Norvège",
  "Oman",
  "Pakistan",
  "Palau",
  "Territoire palestinien, occupé",
  "Panama",
  "Papouasie Nouvelle Guinée",
  "Paraguay",
  "Pérou",
  "Philippines",
  "Pitcairn",
  "Pologne",
  "Le Portugal",
  "Porto Rico",
  "Qatar",
  "Réunion",
  "Roumanie",
  "Fédération Russe",
  "Rwanda",
  "Saint Barthélemy",
  "Sainte-Hélène",
  "Saint-Christophe-et-Niévès",
  "Sainte-Lucie",
  "Saint Martin",
  "Saint-Pierre-et-Miquelon",
  "Saint-Vincent-et-les-Grenadines",
  "Samoa",
  "Saint Marin",
  "Sao Tomé et Principe",
  "Arabie Saoudite",
  "Sénégal",
  "Serbie",
  "Serbie et Monténégro",
  "les Seychelles",
  "Sierra Leone",
  "Singapour",
  "St Martin",
  "Slovaquie",
  "Slovénie",
  "Les îles Salomon",
  "Somalie",
  "Afrique du Sud",
  "Géorgie du Sud et îles Sandwich du Sud",
  "Soudan du sud",
  "Espagne",
  "Sri Lanka",
  "Soudan",
  "Suriname",
  "Svalbard et Jan Mayen",
  "Swaziland",
  "Suède",
  "la Suisse",
  "République arabe syrienne",
  "Taiwan, Province de Chine",
  "Tadjikistan",
  "Tanzanie, République-Unie de",
  "Thaïlande",
  "Timor-Leste",
  "Aller",
  "Tokelau",
  "Tonga",
  "Trinité-et-Tobago",
  "Tunisie",
  "dinde",
  "Turkménistan",
  "îles Turques-et-Caïques",
  "Tuvalu",
  "Ouganda",
  "Ukraine",
  "Emirats Arabes Unis",
  "Royaume-Uni",
  "États-Unis",
  "Îles mineures éloignées des États-Unis",
  "Uruguay",
  "Ouzbékistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Îles Vierges britanniques",
  "Îles Vierges américaines, États-Unis",
  "Wallis et Futuna",
  "Sahara occidental",
  "Yémen",
  "Zambie",
  "Zimbabwe",
];

Settings.countries_de = [
  "Afghanistan",
  "Aland Islands",
  "Albanien",
  "Algerien",
  "Amerikanischen Samoa-Inseln",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarktis",
  "Antigua und Barbuda",
  "Argentinien",
  "Armenien",
  "Aruba",
  "Australien",
  "Österreich",
  "Aserbaidschan",
  "Bahamas",
  "Bahrain",
  "Bangladesch",
  "Barbados",
  "Weißrussland",
  "Belgien",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivien",
  "Bonaire, Sint Eustatius und Saba",
  "Bosnien und Herzegowina",
  "Botswana",
  "Bouvet Island",
  "Brasilien",
  "Britisches Territorium des Indischen Ozeans",
  "Brunei Darussalam",
  "Bulgarien",
  "Burkina Faso",
  "Burundi",
  "Kambodscha",
  "Kamerun",
  "Kanada",
  "Kap Verde",
  "Cayman Inseln",
  "Zentralafrikanische Republik",
  "Tschad",
  "Chile",
  "China",
  "Weihnachtsinsel",
  "Kokosinseln (Keelinginseln)",
  "Kolumbien",
  "Komoren",
  "Kongo",
  "Kongo, Demokratische Republik Kongo",
  "Cookinseln",
  "Costa Rica",
  "Elfenbeinküste",
  "Kroatien",
  "Kuba",
  "Curacao",
  "Zypern",
  "Tschechien",
  "Dänemark",
  "Dschibuti",
  "Dominica",
  "Dominikanische Republik",
  "Ecuador",
  "Ägypten",
  "El Salvador",
  "Äquatorialguinea",
  "Eritrea",
  "Estland",
  "Äthiopien",
  "Falklandinseln (Malvinas)",
  "Färöer Inseln",
  "Fidschi",
  "Finnland",
  "Frankreich",
  "Französisch-Guayana",
  "Französisch Polynesien",
  "Südfranzösische Territorien",
  "Gabun",
  "Gambia",
  "Georgia",
  "Deutschland",
  "Ghana",
  "Gibraltar",
  "Griechenland",
  "Grönland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island und McDonald Islands",
  "Heiliger Stuhl (Staat der Vatikanstadt)",
  "Honduras",
  "Hongkong",
  "Ungarn",
  "Island",
  "Indien",
  "Indonesien",
  "Iran, Islamische Republik",
  "Irak",
  "Irland",
  "Isle of Man",
  "Israel",
  "Italien",
  "Jamaika",
  "Japan",
  "Jersey",
  "Jordanien",
  "Kasachstan",
  "Kenia",
  "Kiribati",
  "Korea, Demokratische Volksrepublik",
  "Korea, Republik von",
  "Kosovo",
  "Kuwait",
  "Kirgisistan",
  "Demokratische Volksrepublik Laos",
  "Lettland",
  "Libanon",
  "Lesotho",
  "Liberia",
  "Libyscher arabischer Jamahiriya",
  "Liechtenstein",
  "Litauen",
  "Luxemburg",
  "Macao",
  "Mazedonien, die ehemalige jugoslawische Republik",
  "Madagaskar",
  "Malawi",
  "Malaysia",
  "Malediven",
  "Mali",
  "Malta",
  "Marshallinseln",
  "Martinique",
  "Mauretanien",
  "Mauritius",
  "Mayotte",
  "Mexiko",
  "Mikronesien, Föderierte Staaten von",
  "Moldawien, Republik",
  "Monaco",
  "Mongolei",
  "Montenegro",
  "Montserrat",
  "Marokko",
  "Mosambik",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Niederlande",
  "Niederländische Antillen",
  "Neu-Kaledonien",
  "Neuseeland",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolkinsel",
  "Nördliche Marianneninseln",
  "Norwegen",
  "Oman",
  "Pakistan",
  "Palau",
  "Besetzte palästinensische Gebiete",
  "Panama",
  "Papua Neu-Guinea",
  "Paraguay",
  "Peru",
  "Philippinen",
  "Pitcairn",
  "Polen",
  "Portugal",
  "Puerto Rico",
  "Katar",
  "Wiedervereinigung",
  "Rumänien",
  "Russische Föderation",
  "Ruanda",
  "Heiliger Barthelemy",
  "Heilige Helena",
  "St. Kitts und Nevis",
  "St. Lucia",
  "Sankt Martin",
  "Saint Pierre und Miquelon",
  "St. Vincent und die Grenadinen",
  "Samoa",
  "San Marino",
  "Sao Tome und Principe",
  "Saudi-Arabien",
  "Senegal",
  "Serbien",
  "Serbien und Montenegro",
  "Seychellen",
  "Sierra Leone",
  "Singapur",
  "St. Martin",
  "Slowakei",
  "Slowenien",
  "Salomon-Inseln",
  "Somalia",
  "Südafrika",
  "Süd-Georgien und die südlichen Sandwich-Inseln",
  "Südsudan",
  "Spanien",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Spitzbergen und Jan Mayen",
  "Swasiland",
  "Schweden",
  "Schweiz",
  "Syrische Arabische Republik",
  "Taiwan, Provinz Chinas",
  "Tadschikistan",
  "Tansania, Vereinigte Republik",
  "Thailand",
  "Timor-Leste",
  "Gehen",
  "Tokelau",
  "Tonga",
  "Trinidad und Tobago",
  "Tunesien",
  "Truthahn",
  "Turkmenistan",
  "Turks- und Caicosinseln",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "Vereinigte Arabische Emirate",
  "Vereinigtes Königreich",
  "Vereinigte Staaten",
  "Kleinere abgelegene Inseln der Vereinigten Staaten",
  "Uruguay",
  "Usbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Virgin Inseln, Britisch",
  "Jungferninseln, USA",
  "Wallis und Futuna",
  "Westsahara",
  "Jemen",
  "Sambia",
  "Zimbabwe",
];

export default Settings;
